import { Col, Row, Typography } from 'antd'
import styled from 'styled-components'
import dayjs from 'dayjs'

import { Note } from '@types'

const { Text } = Typography

const avatarSize = 2

const RowContainer = styled(Row)`
  padding-left: 0.5rem;
  flex-wrap: nowrap;
  margin-bottom: 0.5rem;
`

const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: ${avatarSize}rem;
  width: ${avatarSize}rem;
  background-color: ${props => props.theme.darkGray};
  font-weight: 700;
  line-height: 0px;
`

const Username = styled.p`
  font-weight: 700;
  margin-bottom: 0;
  margin-top: 5px;
`

const Date = styled.p`
  color: #a1a1a1;
  margin-bottom: 0;
`

interface NoteElementProps {
  data: Note
}

const NoteElement = ({ data }: NoteElementProps) => (
  <RowContainer gutter={8}>
    <Col>
      <Avatar>
        {data.user?.userDetail &&
          data.user.userDetail.name[0].toUpperCase() +
            data.user.userDetail.surname[0].toUpperCase()}
      </Avatar>
    </Col>
    <Col>
      <Username>{`${data.user?.userDetail.name} ${data.user?.userDetail.surname}`}</Username>
      <Date>
        {data.updateAt
          ? dayjs(data.updateAt).format('L[,] LT')
          : dayjs(data.createAt).format('L[,] LT')}
      </Date>
      <Text>{data.description}</Text>
    </Col>
  </RowContainer>
)

export { NoteElement }
